module.exports = __webpack_public_path__ + "img/gold_symbol_5.a280cbdf.png";